import styled from "styled-components";

import {
  ANNOTATION_PANEL_MIN_HEIGHT,
  ANNOTATION_PANEL_MIN_HEIGHT_WITH_LEAD,
  STUDIO_BREAKPOINT,
  STUDIO_MEDIA_COLUMN_MIN_HEIGHT,
  STUDIO_MIN_HEIGHT,
  STUDIO_MIN_HEIGHT_WITH_LEAD,
  STUDIO_PANEL_WIDTH,
  STUDIO_PANEL_WIDTH_COMPACT,
  STUDIO_STACKED_MIN_HEIGHT,
  STUDIO_STACKED_MIN_HEIGHT_WITH_LEAD,
} from "./MediaAnnotationStudioConstraint";

export const MediaAnnotationStudioRoot = styled.section<{ $leadSection?: boolean }>`
  display: flex;
  width: 100%;
  height: 100%;
  min-width: 0;
  /* 바닥은 제약 모듈이 부분의 합에서 계산한다 — 임의의 값을 박으면 내부가 잘린다.
     제품이 선두 자리를 세우면 그 자리의 바닥만큼 합이 커진다. 자리를 주지 않은 소비처의
     바닥은 그대로다. */
  min-height: ${({ $leadSection = false }) =>
    $leadSection ? STUDIO_MIN_HEIGHT_WITH_LEAD : STUDIO_MIN_HEIGHT};
  flex-direction: column;
  overflow: hidden;
  background: ${({ theme }) => theme.color.bg.surface};
  container-name: media-annotation-studio;
  container-type: inline-size;
`;

export const MediaAnnotationStudioMain = styled.main<{ $leadSection?: boolean }>`
  display: flex;
  min-width: 0;
  min-height: 0;
  flex-direction: column;
  background: ${({ theme }) => theme.color.bg.surface};

  @container media-annotation-studio (max-width: ${STUDIO_BREAKPOINT.stackedPanel}) {
    min-height: ${({ $leadSection = false }) =>
      $leadSection ? STUDIO_STACKED_MIN_HEIGHT_WITH_LEAD : STUDIO_STACKED_MIN_HEIGHT};
  }
`;

export const MediaAnnotationWorkspace = styled.div`
  display: flex;
  min-width: 0;
  min-height: 0;
  flex-direction: column;
`;

export const MediaAnnotationWorkspaceBody = styled.div<{
  $showAnnotationPanel: boolean;
  $leadSection?: boolean;
}>`
  display: grid;
  min-width: 0;
  min-height: 0;
  flex: 1;
  grid-template-columns: ${({ $showAnnotationPanel }) =>
    $showAnnotationPanel
      ? `minmax(0, 1fr) clamp(${STUDIO_PANEL_WIDTH.min}, ${STUDIO_PANEL_WIDTH.ideal}, ${STUDIO_PANEL_WIDTH.max})`
      : "minmax(0, 1fr)"};

  @container media-annotation-studio (max-width: ${STUDIO_BREAKPOINT.compactPanel}) {
    grid-template-columns: ${({ $showAnnotationPanel }) =>
      $showAnnotationPanel ? `minmax(0, 1fr) ${STUDIO_PANEL_WIDTH_COMPACT}` : "minmax(0, 1fr)"};
  }

  @container media-annotation-studio (max-width: ${STUDIO_BREAKPOINT.stackedPanel}) {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: ${({ $showAnnotationPanel, $leadSection = false }) =>
      $showAnnotationPanel
        ? `minmax(${STUDIO_MEDIA_COLUMN_MIN_HEIGHT}, 0.8fr) minmax(${
            $leadSection ? ANNOTATION_PANEL_MIN_HEIGHT_WITH_LEAD : ANNOTATION_PANEL_MIN_HEIGHT
          }, 1.2fr)`
        : `minmax(${STUDIO_MEDIA_COLUMN_MIN_HEIGHT}, 1fr)`};
  }
`;
